export function checkMediaQuery(){
    const mediaQuery = window.matchMedia('(max-width: 800px)')
    return mediaQuery.matches
}